import { Talep } from './talep';

export class TaleplerPage {

  currentPage: number;
  pageCount: number;
  pageSize: number;
  rowCount: number;
  firstRowOnPage: number;
  lastRowOnPage: number;
  private pResults: Talep[];
  isTalep: boolean; // talepler sayfası ise Teklif iste butonu gözükmesin
  isFatura: boolean;
  isSiparis: boolean;
  isTeklif: boolean;
  // isTeklifSiparis: boolean;
  teklifVeren: number;

  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
  }

  public get results(): Talep[] {
    return this.pResults;
  }

  public set results(list: Talep[]) {
    if (list != null) {
      this.pResults = list.map(t => new Talep(t));
    }
  }

}
